<template>
  <div class="left-menu">
    <div class="btn" :class="{ active: activeRouter === 'WarningManage' }" @click="pathTo('WarningManage')"><i class="iconfont icon-alarm-full"></i>报警管理</div>
    <div class="btn" @click="pathTo(false)"><i class="iconfont icon-suanfamoxing"></i>算法管理</div>
  </div>
</template>

<script>
export default {
  name: "LeftMenu",
  props: {
    activeRouter: { type: String, default: 'VideoSurveillance' }
  },
  methods: {
    pathTo (name) {
      if (!name) {
        return this.$message.warning('该模块开发中...')
      }
      this.$router.push({ name: name })
    }
  }
}
</script>

<style scoped lang="less">
.left-menu{
  padding: 42px 0;
  .btn{
    margin: 0 48px 26px 48px;
    cursor: pointer;
    width: 215px;
    height: 68px;
    text-align: center;
    line-height: 68px;
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
    background-image: url("../../../assets/img/btn.png");
    background-size: 100% 100%;
    i{
      font-size: 28px;
      margin-right: 10px;
    }
  }
  .active{
    width: 225px;
    margin-left: 43px;
    margin-right: 43px;
    height: 74px;
    line-height: 74px;
    background-image: url("../../../assets/img/btn-active.png");
  }
}
</style>
